import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const playingWithFood: BlogMetaData = {
  title: '遊び食べはいつまで？原因・対処法とNG対応をモンテッソーリ視点で解説',
  description:
    '遊び食べで食事が進まない、散らかす、集中しないとお悩みではありませんか。原因と今日からできる対処法、やってはいけないNG対応を、モンテッソーリの「探索」の視点でやさしく解説します。',
  thumbnailUrl: '/img/blog-playing-with-food.webp',
  filePath: buildBlogFilePath('playing-with-food'),
  category: BLOG_CATEGORY.PARENTING,
};
